import { UserRoleValue } from "../constants/field-values";
import routeNames from "../constants/route-names";

const baseUrl = process.env.PUBLIC_URL;

// Define permissions by route
export const ROUTE_PERMISSIONS: Record<string, UserRoleValue[]> = {
	// Admin dashboard accessible to all admin roles
	[routeNames.ADMIN_DASHBOARD]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.customer_manager,
		UserRoleValue.vendor_employee
	],

	// Device routes - accessible to vendor roles
	[routeNames.ADMIN_DEVICES]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager, UserRoleValue.vendor_employee],
	[routeNames.ADMIN_DEVICES_ADD]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager],
	[routeNames.ADMIN_DEVICES_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_DEVICES_EDIT]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],

	// User routes - accessible to managers
	[routeNames.ADMIN_USERS]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager, UserRoleValue.customer_manager],
	[routeNames.ADMIN_USER_ADD]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager, UserRoleValue.customer_manager],
	[routeNames.ADMIN_USER_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.customer_manager
	],
	[routeNames.ADMIN_USER_EDIT]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.customer_manager
	],

	// Organization routes - admin_user only
	[routeNames.ADMIN_ORGANIZATIONS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.customer_manager
	],
	// A customer belongs to a single organization and never brings in others
	[routeNames.ADMIN_ORGANIZATION_ADD]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager],
	[routeNames.ADMIN_ORGANIZATION_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.customer_manager
	],
	[routeNames.ADMIN_ORGANIZATION_EDIT]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.customer_manager
	],

	// Property routes - customer and admin
	[routeNames.ADMIN_PROPERTIES]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_PROPERTY_ADD]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_PROPERTY_EDIT]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_PROPERTY_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],

	// Routes of installed devices
	[routeNames.ADMIN_INSTALLED_DEVICE_ADD]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_INSTALLED_DEVICE_EDIT]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_INSTALLED_DEVICES_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager
	],

	// Other admin routes
	[routeNames.ADMIN_TIERS]: [UserRoleValue.admin_user],
	[routeNames.ADMIN_AI_MODELS]: [UserRoleValue.admin_user],
	[routeNames.ADMIN_SHOP_PRODUCT_ADD]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.ADMIN_SHOP_PRODUCTS_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager
	],
	[routeNames.ADMIN_INTELLIGENCE]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager
	],
	[routeNames.ADMIN_DEVICE_DETECTIONS]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager],
	[routeNames.ADMIN_DEVICE_DETECTION_ADD]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager],
	[routeNames.ADMIN_DEVICE_DETECTION_DETAILS]: [UserRoleValue.admin_user, UserRoleValue.vendor_manager],

	// ollie / inspections
	[routeNames.OLLIE_CHAT]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee
	],
	[routeNames.OLLIE_DASHBOARD]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee
	],
	[routeNames.OLLIE_INSPECTION_ADD]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee
	],
	[routeNames.OLLIE_INSPECTION_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee
	],
	[routeNames.OLLIE_EVIDENCE_COLLECTION]: [
		UserRoleValue.admin_user,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee
	],

	// handovers
	[routeNames.HANDOVERS]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.HANDOVERS_ADD]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.HANDOVER_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.HANDOVER_DEVICE_DETECTION_ADD]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],
	[routeNames.HANDOVER_DEVICE_DETECTION_DETAILS]: [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee
	],

	// The two AHJ map screens are platform admin only, and they are listed here on
	// purpose even though admin_user short-circuits every check above. Leaving them out
	// of the map would give the same result today by accident, and the day somebody adds
	// either one to publicRoutes or AUTHORITY_ROUTES it would open silently. Loading a
	// boundary map decides which authority every filing in a region is sent to, and a
	// wrong one is invisible on screen, so this stays with us.
	[routeNames.BOUNDARY_LAYERS]: [UserRoleValue.admin_user],
	[routeNames.BOUNDARY_AUTHORITY_PROPOSALS]: [UserRoleValue.admin_user],

	// Approving a claim makes the person a manager of an AHJ, so only platform admins decide it.
	[routeNames.ADMIN_AUTHORITY_CLAIMS]: [UserRoleValue.admin_user],

	// Importing a code book is us loading a published code into the platform, not an
	// authority configuring its own review: the books it produces are read by every
	// jurisdiction, so a bad import is not a local mistake. The authority screens stop
	// at which codes it adopts (PLAN_REVIEW_CODES), which stays open to its staff.
	[routeNames.PLAN_REVIEW_CODE_IMPORTS]: [UserRoleValue.admin_user],
	[routeNames.PLAN_REVIEW_CODE_IMPORT]: [UserRoleValue.admin_user]
};

const publicRoutes = [
	routeNames.HOME,
	routeNames.LOGIN,
	routeNames.SIGNUP,
	routeNames.EMAIL_VERIFICATION_PENDING,
	routeNames.FORGOT_PASSWORD,
	// routeNames.VERIFY_CODE,
	// routeNames.NEW_PASSWORD,
	routeNames.DASHBOARD,
	routeNames.NOTIFICATIONS,
	routeNames.ORDER,
	routeNames.REQUEST_SERVICE,
	// routeNames.PROFILE,
	routeNames.GUIDES,
	routeNames.GUIDE_DETAILS,
	routeNames.GUIDE_DETAILS_EDIT,
	routeNames.GUIDE_ADD,
	routeNames.INSTALLED_DEVICES,
	routeNames.INSTALLED_DEVICE_DETAILS,
	routeNames.INSTALLED_DEVICES_DETAILS,
	routeNames.SHOP_PRODUCTS_DETAILS,
	routeNames.AI_CHAT,
	routeNames.CHECKOUT,
	routeNames.EAGLE_EYE,
	routeNames.OLLIE_CHAT,
	routeNames.OLLIE_DASHBOARD,
	routeNames.OLLIE_INSPECTION_ADD,
	routeNames.OLLIE_EVIDENCE_COLLECTION,
	routeNames.OLLIE_INSPECTION_DETAILS,
	routeNames.PLAN_REVIEW_ADD,
	routeNames.PLAN_REVIEW_COLLECTION,
	routeNames.PLAN_REVIEW_COLLECTION_RESUBMIT,
	routeNames.PLAN_REVIEW_SUBMISSIONS,
	routeNames.PLAN_REVIEW_DETAILS,
	routeNames.NOT_FOUND
];

publicRoutes.forEach(route => {
	ROUTE_PERMISSIONS[route] = [
		UserRoleValue.admin_user,
		UserRoleValue.customer_manager,
		UserRoleValue.customer_employee,
		UserRoleValue.vendor_manager,
		UserRoleValue.vendor_employee,
		UserRoleValue.basic
	];
});

// An Authority (AHJ) organization reviews what others build: it works through
// inspections, plan reviews and the guides and devices behind them. Ordering,
// service requests and handovers are not part of that, so those routes — and the
// side-nav items that lead to them — stay out of the list entirely.
const AUTHORITY_ROUTES = [
	routeNames.HOME,
	routeNames.LOGIN,
	routeNames.SIGNUP,
	routeNames.EMAIL_VERIFICATION_PENDING,
	routeNames.FORGOT_PASSWORD,
	routeNames.DASHBOARD,
	routeNames.NOTIFICATIONS,
	routeNames.AI_CHAT,
	routeNames.GUIDES,
	routeNames.GUIDE_DETAILS,
	routeNames.GUIDE_DETAILS_EDIT,
	routeNames.GUIDE_ADD,
	routeNames.INSTALLED_DEVICES,
	routeNames.INSTALLED_DEVICE_DETAILS,
	routeNames.INSTALLED_DEVICES_DETAILS,
	routeNames.OLLIE_CHAT,
	routeNames.OLLIE_DASHBOARD,
	routeNames.OLLIE_INSPECTION_ADD,
	routeNames.OLLIE_INSPECTION_DETAILS,
	routeNames.OLLIE_EVIDENCE_COLLECTION,
	routeNames.PLAN_REVIEW_ADD,
	routeNames.PLAN_REVIEW_COLLECTION,
	routeNames.PLAN_REVIEW_COLLECTION_RESUBMIT,
	routeNames.PLAN_REVIEW_SUBMISSIONS,
	routeNames.PLAN_REVIEW_DETAILS,
	// What the jurisdiction screens submittals against. The whole authority reads them —
	// staff answer applicants from these every day — while only a manager changes them,
	// which the screens themselves enforce.
	routeNames.PLAN_REVIEW_RULES,
	routeNames.PLAN_REVIEW_EXTRACTIONS,
	routeNames.PLAN_REVIEW_RULES_EXTRACTION,
	routeNames.PLAN_REVIEW_RESOURCES,
	routeNames.PLAN_REVIEW_SUBMISSION_TYPES,
	routeNames.PLAN_REVIEW_FEE_SCHEDULE,
	routeNames.PLAN_REVIEW_CATEGORIES,
	routeNames.PLAN_REVIEW_CODES,
	routeNames.NOT_FOUND
];

// Admin is manager-only: the staff role has no Users or Organizations page. Neither
// role creates organizations — an authority manages the one it belongs to.
const AUTHORITY_MANAGER_ROUTES = [
	routeNames.ADMIN_DASHBOARD,
	routeNames.ADMIN_USERS,
	routeNames.ADMIN_USER_ADD,
	routeNames.ADMIN_USER_DETAILS,
	routeNames.ADMIN_USER_EDIT,
	routeNames.ADMIN_ORGANIZATIONS,
	routeNames.ADMIN_ORGANIZATION_DETAILS,
	routeNames.ADMIN_ORGANIZATION_EDIT
];

AUTHORITY_ROUTES.forEach(route => {
	ROUTE_PERMISSIONS[route] = [
		...(ROUTE_PERMISSIONS[route] || []),
		UserRoleValue.authority_manager,
		UserRoleValue.authority_user
	];
});

AUTHORITY_MANAGER_ROUTES.forEach(route => {
	ROUTE_PERMISSIONS[route] = [...(ROUTE_PERMISSIONS[route] || []), UserRoleValue.authority_manager];
});

// Function to check if a user has permission to access a route
export const hasRoutePermission = (route: string, userRole?: UserRoleValue): boolean => {
	// Without a defined role, there is no access
	if (!userRole) return false;

	// admin_user has access to all routes
	if (userRole === UserRoleValue.admin_user) return true;

	// Check specific permits for the route
	const allowedRoles = ROUTE_PERMISSIONS[route];

	// If the route is not in the permission map, deny access
	if (!allowedRoles) return false;

	// Check if the user's role is in the list of allowed roles
	return allowedRoles.includes(userRole);
};

// Routes under these prefixes are fully accessible to anonymous users,
// including all nested sub-paths (e.g. /properties/123/proof-center/system-name).
const ANONYMOUS_ROUTE_PREFIXES = [routeNames.PROOF_CENTER, routeNames.CLAIM_JURISDICTION].map(route => route.split("/:")[0].replace(baseUrl, ""));

// Only these specific parameterized routes are accessible to anonymous users.
// Sibling routes like /guides/add or /handovers are NOT allowed.
const ANONYMOUS_ROUTE_EXACT = [routeNames.GUIDE_DETAILS, routeNames.HANDOVER_DETAILS].map(
	route => new RegExp(`^${route.replace(baseUrl, "").replace(/:[^/]+/g, "[^/]+")}$`)
);

export const isAnonymousRoute = (pathname: string) => {
	if (ANONYMOUS_ROUTE_PREFIXES.some(prefix => pathname.startsWith(prefix))) return true;
	if (ANONYMOUS_ROUTE_EXACT.some(regex => regex.test(pathname))) return true;
	return false;
};
